/**
 * UI Pinia Store — FULLY IMPLEMENTED
 * Replaces the root Vuex state (toast, darkMode, loading) from src/store/index.js.
 */
import { defineStore } from 'pinia'
import type { UIState, ToastState, ToastType } from '@/shared/types'

let toastTimer: ReturnType<typeof setTimeout> | null = null

export const useUIStore = defineStore('ui', {
  state: (): UIState => ({
    toast: {
      open: false,
      message: 'Toast Message',
      type: 'primary',
      duration: 2000,
    },
    darkMode: false,
    loading: {
      isLoading: false,
      message: '',
    },
  }),

  getters: {
    getToast: (state): ToastState => state.toast,
    isDarkMode: (state): boolean => state.darkMode,
    isLoading: (state): boolean => state.loading.isLoading,
    loadingMessage: (state): string => state.loading.message,
  },

  actions: {
    updateToast(payload: { open?: boolean; message?: string; type?: ToastType; duration?: number }): void {
      this.toast.open = payload.open ?? false
      this.toast.message = payload.message ?? 'Toast Message'
      this.toast.type = payload.type ?? 'primary'
      this.toast.duration = payload.duration ?? 2000

      if (toastTimer !== null) {
        clearTimeout(toastTimer)
        toastTimer = null
      }

      if (this.toast.open && this.toast.duration) {
        toastTimer = setTimeout(() => {
          this.toast.open = false
          toastTimer = null
        }, this.toast.duration)
      }
    },

    updateDarkMode(value?: boolean): void {
      this.darkMode = typeof value === 'boolean' ? value : !this.darkMode
    },

    updateLoading(payload: { isLoading: boolean; message?: string }): void {
      this.loading.isLoading = payload.isLoading ?? false
      this.loading.message = this.loading.isLoading ? (payload.message ?? 'Loading...') : ''
    },
  },
})
